// extracted by mini-css-extract-plugin
export var actions = "_f2-g";
export var benefitCard = "_f2-b";
export var benefitIcon = "_f2-d";
export var benefitLabel = "_f2-f";
export var benefits = "_f2-a";
export var benefitsSection = "_f2-8";
export var bodyText = "_f2-7";
export var closeButton = "_f2-2";
export var content = "_f2-3";
export var eyebrow = "_f2-4";
export var heading = "_f2-5";
export var image = "_f2-i";
export var imagePanel = "_f2-h";
export var modal = "_f2-0";
export var offerCard = "_f2-c";
export var offerIcon = "_f2-e";
export var sectionLabel = "_f2-9";
export var shell = "_f2-1";
export var title = "_f2-6";